export default __webpack_public_path__ + "static/media/clap.5036abe5.mp3";